import React from "react";
import "./campaign.css";

const Campaign: React.FC = () => {
	return (
		<div className="campaign__container">
			<div className="campaign__wrapper">
				<img src="/img/widgets/banner.png" alt="" />
			</div>
		</div>
	);
};

export const SmallWideBanner: React.FC = () => {
	return (
		<div className="campaign__container">
			<div className="campaign__wrapper">
				<img src="/img/widgets/two-collum-wide.png" alt="" />
			</div>
		</div>
	);
};

export const TrendingProducts: React.FC = () => {
	return (
		<div className="campaign__container">
			<div className="campaign__wrapper">
				<img
					src="/img/widgets/trending-product.png"
					alt=""
					style={{ width: "100%" }}
				/>
			</div>
		</div>
	);
};

export const FilterProducts: React.FC = () => {
	return (
		<div className="campaign__container">
			<div className="campaign__wrapper">
				<img src="/img/widgets/filter-products.png" alt="" />
			</div>
		</div>
	);
};

export const RandomBanners: React.FC = () => {
	return (
		<div className="campaign__container">
			<div className="campaign__wrapper">
				<img src="/img/widgets/random-banners.png" alt="" />
			</div>
		</div>
	);
};

export const ThreeBannersProducts: React.FC = () => {
	return (
		<div className="campaign__container w-full">
			<div className="campaign__wrapper">
				<img
					src="/img/widgets/three-banner-products.png"
					style={{ width: "100%" }}
					alt=""
				/>
			</div>
		</div>
	);
};

export const ServicesBanner: React.FC = () => {
	return (
		<div className="campaign__container">
			<div className="campaign__wrapper">
				<img src="/img/widgets/services.jpg" alt="" />
			</div>
		</div>
	);
};

export const AuthorsBanner: React.FC = () => {
	return (
		<div className="campaign__container">
			<div className="campaign__wrapper">
				<img
					className="object-cover object-center w-full"
					style={{
						aspectRatio: 100 / 20,
					}}
					src="/img/widgets/authors.jpg"
					alt=""
				/>
			</div>
		</div>
	);
};

export const BlogBanner: React.FC = () => {
	return (
		<div className="campaign__container">
			<div className="campaign__wrapper">
				<div className="w-full h-[150px] flex gap-4 justify-center">
					{[...Array(3)].map((_, i) => (
						<div key={i} className="flex w-[30%] flex-col gap-4">
							<div className="skeleton h-[40%] w-full"></div>
							<div className="skeleton h-[6%] w-[25%]"></div>
							<div className="skeleton h-[6%] w-full"></div>
							<div className="skeleton h-[6%] w-full"></div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export const VideoBanner: React.FC = () => {
	return (
		<div className="campaign__container">
			<div className="campaign__wrapper">
				<img src="/img/widgets/video.png" alt="" />
			</div>
		</div>
	);
};

export const CheckoutSkeleton: React.FC = () => {
	return (
		<div className="campaign__container">
			<div className="campaign__wrapper">
				<img src="/img/checkout.jpg" alt="" />
			</div>
		</div>
	);
};

export const ReviewsSlider: React.FC = () => {
	return (
		<div className="campaign__container">
			<div className="campaign__wrapper">
				<img src="/img/widgets/reviews.jpg" alt="" />
			</div>
		</div>
	);
};

export default Campaign;
